export default "__VITE_ASSET__$MXRT5bH__"